export type ArrayOp<E, V> = (element:E, index:number) => V;

export abstract class ArrayUtils
{
    public static reorderArray<T>(array:T[], from:number, to:number, length = 1):T[]
    {
        const itemsToMove = array.slice(from, from + length);

        let newArray = [
            ...array.slice(0, from),
            ...array.slice(from + length)
        ];

        return [
            ...newArray.slice(0, to),
            ...itemsToMove,
            ...newArray.slice(to)
        ];
    }

    public static async asyncForEach<T>(array:T[],
                                        callbackFn:(value:T, index:number, array:T[]) => void,
                                        maxTimePerChunk:number = 30,
                                        thisArg:any = array):Promise<void>
    {
        const waitFor = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        let startTime = Date.now();

        for( let i = 0; i < array.length; i++ )
        {
            if( (Date.now() - startTime) > maxTimePerChunk )
            {
                await waitFor(0);
                startTime = Date.now();
            }

            callbackFn.call(thisArg, array[i], i, array);
        }
    }

    public static keyMap<E>(a:Array<E>, keyFn:ArrayOp<E, string>):{[key:string]:E}
    {
        return this.arrayToMap(a, keyFn, v => v);
    }

    public static arrayToMap<E, V>(a:Array<E>, keyFn:ArrayOp<E, string>, valueFn?:ArrayOp<E, V>):{[key:string]:V}
    {
        const result = {};
        a.forEach((e, ind) =>
        {
            const key = keyFn(e, ind);
            if( key )
                result[key] = valueFn ? valueFn(e, ind) : true;
        });
        return result;
    }

    // this utility is a bit strange, but still usefull
    public static arrayToFlatMap<E, V>(a:Array<E>, keyFn:ArrayOp<E, Array<string>>, valueFn?:ArrayOp<E, V>):{[key:string]:V}
    {
        const result = {};
        a.forEach((e, ind) =>
        {
            const keys = keyFn(e, ind);
            if( keys && keys.length > 0 )
            {
                const value = valueFn ? valueFn(e, ind) : true;
                keys.forEach(key => result[key] = value);
            }
        });
        return result;
    }

    public static groupArray<E, V>(a:Array<E>, keyFn:ArrayOp<E, string>, valueFn?:ArrayOp<E, V>):{[key:string]:Array<V>}
    {
        const groups = {};
        a.forEach((e, ind) =>
        {
            const key = keyFn(e, ind);
            if( key != null )
            {
                let group = groups[key];
                if( !group )
                    groups[key] = group = [];

                group.push(
                    valueFn ? valueFn(e, ind) : e
                );
            }
        });
        return groups;
    }

    public static newArray<T>(length:number, generator:(i:number) => T):Array<T>
    {
        const result = Array(length);
        for( let i = 0; i < length; ++i )
            result[i] = generator(i);
        return result;
    }
}
